/**
 * Bulk Order Inquiry 폼 단일 출처.
 *
 * 두 진입점이 같은 폼을 사용:
 * - DK3 BuyBox "Contact us for a bulk order"
 * - Cart Sheet Purchase Limit 다이얼로그 "Contact"
 *
 * 폼 필드 변경 시 이 파일만 수정하면 두 곳 모두 자동 반영.
 */
export const BULK_ORDER_SUBJECT = "Bulk Order Inquiry";

export function buildBulkOrderBody(
  opts: { desiredProduct?: string } = {},
): string {
  return [
    "Bulk Order Inquiry",
    "",
    "Full company name: ",
    "Billing address: ",
    "Shipping address: ",
    "Recipient contact information (Name, email address, phone number): ",
    `Desired product/model: ${opts.desiredProduct ?? ""}`,
    "Quantity: ",
    "Tax/VAT number (if applicable): ",
    "Intended use purpose (Resell, Distribution, Research, Entertainment): ",
  ].join("\n");
}

export type BulkOrderInquiryInput = {
  replyTo: string;
  body: string;
  website: string;
};

export async function submitBulkOrderInquiry(
  input: BulkOrderInquiryInput,
): Promise<void> {
  // 끝슬래시 필수 — `trailingSlash: true` 라 없으면 308 을 받고 POST body 를 들고 한 번 더 왕복한다.
  // docs/pitfalls.md #20 「… slash 없으면 308 왕복」
  const res = await fetch("/api/support/bulk-order-inquiry/", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) {
    throw new Error(json?.message || "Failed to send. Please try again.");
  }
}
